import {createStore} from 'vuex'
import {Actions, Mutations} from "@/store/enum/StoreEnums";
import {actionTrackerPlugin} from "@/store/plugins/actionTracker";

import Module from "@/store/module";
import AuthModule from "@/store/module/AuthModule";
import BodyModule from "@/store/module/BodyModule";
import BreadcrumbsModule from "@/store/module/BreadcrumbsModule";
import ConfigModule from "@/store/module/ConfigModule";
import Authorized from "@/store/company/Authorized";
import Customer from "@/store/customer";
import Cash from "@/store/cash"
import CashMovement from "@/store/cash/Movement"
import Transaction from "@/store/transaction"
import Stock from "@/store/stock"
import StockCategory from "@/store/stock/Category"
import StockMovement from "@/store/stock/Movement"
import StockLocation from "@/store/stock/Location"
import StockWarehouse from "@/store/stock/Warehouse"
import StockWarehouseShelf from "@/store/stock/Warehouse/Shelf"
import CustomerVehicle from "@/store/customer/Vehicle";
import CompanyModule from "@/store/company/Module";
import VehicleWorkOrder from "@/store/module/vehicle-work-order";
import VehicleWorkOrderItem from "@/store/module/vehicle-work-order/Item";
import VehicleWorkOrderType from "@/store/module/vehicle-work-order/Type";
import VehicleBrand from "@/store/common/vehicle/Brand";
import VehicleModel from "@/store/common/vehicle/Model";
import VehicleModelSearch from "@/store/common/vehicle/ModelSearch";
import VehicleYear from "@/store/common/vehicle/Year";
import Unit from "@/store/common/stock/Unit";
import Note from "@/store/module/note";
import NoteCategory from "@/store/module/note/Category";
import NoteTag from "@/store/module/note/Tag";
import NoteTrash from "@/store/module/note/Trash";
import Officer from "@/store/company/Officer";
import Agenda from "@/store/module/agenda";

export const store = createStore({
    plugins: [actionTrackerPlugin],
    state: () => ({
        access: true,
        forbiddenEndpoints: []
    }),
    getters: {
        isAccess(state) {
            return state.access;
        },
        forbiddenEndpoints(state) {
            return state.forbiddenEndpoints;
        }
    },
    actions: {
        [Actions.ACCESS](context, access) {
            context.commit(Mutations.SET_ACCESS, access);
        },
        [Actions.FORBIDDEN_ENDPOINT](context, access) {
            context.commit(Mutations.SET_FORBIDDEN_ENDPOINT, access);
        }
    },
    mutations: {
        [Mutations.SET_ACCESS](state, access) {
            state.access = access;
        },
        [Mutations.SET_FORBIDDEN_ENDPOINT](state, endpoint) {
            state.forbiddenEndpoints.push(endpoint);
        },
        [Mutations.RESET_FORBIDDEN_ENDPOINT](state) {
            state.forbiddenEndpoints = [];
        },
    },
    modules: {
        AuthModule,
        BodyModule,
        BreadcrumbsModule,
        ConfigModule,
        customer: Object.assign(Customer, {
            modules: {
                vehicle: CustomerVehicle,
            }
        }),
        cash: Object.assign(Cash, {
            modules: {
                movement: CashMovement
            }
        }),
        transaction: Transaction,
        company: Object.assign(Module, {
            modules: {
                authorized: Authorized,
                module: CompanyModule,
                officer: Officer,
            }
        }),
        stock: Object.assign(Stock, {
            modules: {
                category: StockCategory,
                movement: StockMovement,
                location: StockLocation,
                warehouse: Object.assign(StockWarehouse, {
                    modules: {
                        shelf: StockWarehouseShelf,
                    }
                }),
            }
        }),
        vehicle: {
            namespaced: true,
            modules: {
                brand: VehicleBrand,
                model: VehicleModel,
                model_search: VehicleModelSearch,
                year: VehicleYear,
            }
        },
        module: {
            namespaced: true,
            modules: {
                vehicle_work_order: Object.assign(VehicleWorkOrder, {
                    modules: {
                        type: VehicleWorkOrderType,
                        item: VehicleWorkOrderItem,
                    }
                }),
                note: Object.assign(Note, {
                    modules: {
                        category: NoteCategory,
                        tag: NoteTag,
                        trash: NoteTrash,
                    }
                }),
                agenda: Agenda,
            }
        },
        common: {
            namespaced: true,
            modules: {
                unit: Unit,
            }
        }
        /*
        module: Object.assign(Module, {
            modules: {
                kind: ModuleKind,
            }
        }),
         */
    }
});


export default store;